// extracted by mini-css-extract-plugin
module.exports = {"option":"DadataInput-module__option___2f0FL","option_bold":"DadataInput-module__option_bold___1qjVi","manual":"DadataInput-module__manual___2c9Qz"};